"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DateProvider_1 = require("@zapier/date/dist/components/DateProvider");
const formatDateTime_1 = __importDefault(require("@zapier/date/dist/utils/formatDateTime"));
const formatTimeSpan_1 = __importDefault(require("@zapier/date/dist/utils/formatTimeSpan"));
const getClientTimeZone_1 = __importDefault(require("@zapier/date/dist/utils/getClientTimeZone"));
const RelativeTime = (props) => {
    const { date, formatter = formatTimeSpan_1.default, hasSuffix } = props;
    // Get timezone from AppProvider (if exists)
    const { timezone } = DateProvider_1.useDate();
    // fallback to client timezone then to UTC if that fails
    const clientTimezone = timezone || getClientTimeZone_1.default() || 'UTC';
    const formattedISODate = formatDateTime_1.default(date, 'iso', clientTimezone);
    return (react_1.default.createElement("time", { dateTime: formattedISODate, title: formattedISODate }, formatter(Date.now(), date, hasSuffix !== false)));
};
exports.default = RelativeTime;
